import api from "./axiosConfig";
import { LOCAL_PRODUCTS_ENDPOINT, LOCAL_PRODUCTS_FILTERS_COMPOSITION_ENDPOINT, LOCAL_PRODUCTS_FILTERS_CROPS_ENDPOINT, LOCAL_PRODUCTS_FILTERS_PROBLEMATICS_ENDPOINT, LOCAL_PRODUCTS_FILTERS_TYPES_ENDPOINT, LOCAL_PRODUCTS_FILTERS_FAMILIES_ENDPOINT, LOCAL_PRODUCT_ENDPOINT, LOCAL_PRODUCT_BY_NAME_ENDPOINT, LOCAL_PRODUCTS_DISCLAIMER_ENDPOINT } from "./apiEndpoints";
import { logError } from './errorLogService';

export const fetchLocalProducts = async () => {

  try {
    const response = await api.get(LOCAL_PRODUCTS_ENDPOINT());
    return response.data;
  } catch (error) {
    console.error("Error fetching products data", error);

    await logError('local_products_fetch', error, {
      endpoint: LOCAL_PRODUCTS_ENDPOINT(),
      response_status: error.response?.status,
      response_data: error.response?.data,
    });

    throw error;
  }
};

export const fetchLocalProduct = async (productId) => {

  try {
    const response = await api.get(LOCAL_PRODUCT_ENDPOINT(productId));
    return response.data;
  } catch (error) {
    console.error("Error fetching products data", error);

    await logError('local_product_fetch', error, {
      endpoint: LOCAL_PRODUCT_ENDPOINT(productId),
      productId,
      response_status: error.response?.status,
      response_data: error.response?.data,
    });

    throw error;
  }
};

export const fetchLocalProductBySlug = async (countryCode, productSlug) => {

  try {
    const response = await api.get(LOCAL_PRODUCT_BY_NAME_ENDPOINT(countryCode, productSlug));
    return response.data;
  } catch (error) {
    console.error("Error fetching product by slug", error);

    await logError('local_product_by_slug_fetch', error, {
      endpoint: LOCAL_PRODUCT_BY_NAME_ENDPOINT(countryCode, productSlug),
      countryCode,
      productSlug,
      response_status: error.response?.status,
      response_data: error.response?.data,
    });

    throw error;
  }
};

export const fetchFamiliesService = async () => {

  try {
    const response = await api.get(LOCAL_PRODUCTS_FILTERS_FAMILIES_ENDPOINT());
    return response.data;
  } catch (error) {
    console.error("Error fetching crops filters data", error);

    await logError('local_product_families_fetch', error, {
      endpoint: LOCAL_PRODUCTS_FILTERS_FAMILIES_ENDPOINT(),
      response_status: error.response?.status,
      response_data: error.response?.data,
    });

    throw error;
  }
};

export const fetchCropsService = async () => {

  try {
    const response = await api.get(LOCAL_PRODUCTS_FILTERS_CROPS_ENDPOINT());
    return response.data;
  } catch (error) {
    console.error("Error fetching crops filters data", error);

    await logError('local_product_crops_fetch', error, {
      endpoint: LOCAL_PRODUCTS_FILTERS_CROPS_ENDPOINT(),
      response_status: error.response?.status,
      response_data: error.response?.data,
    });

    throw error;
  }
};

export const fetchCompositionService = async () => {

  try {
    const response = await api.get(LOCAL_PRODUCTS_FILTERS_COMPOSITION_ENDPOINT());
    return response.data;
  } catch (error) {
    console.error("Error fetching active ingredients filters data", error);

    await logError('local_product_composition_fetch', error, {
      endpoint: LOCAL_PRODUCTS_FILTERS_COMPOSITION_ENDPOINT(),
      response_status: error.response?.status,
      response_data: error.response?.data,
    });

    throw error;
  }
};

export const fetchProblematicsService = async () => {

  try {
    const response = await api.get(LOCAL_PRODUCTS_FILTERS_PROBLEMATICS_ENDPOINT());
    return response.data;
  } catch (error) {
    console.error("Error fetching problematics filters data", error);

    await logError('local_product_problematics_fetch', error, {
      endpoint: LOCAL_PRODUCTS_FILTERS_PROBLEMATICS_ENDPOINT(),
      response_status: error.response?.status,
      response_data: error.response?.data,
    });

    throw error;
  }
};


export const fetchFormulationTypesService = async () => {

  try {
    const response = await api.get(LOCAL_PRODUCTS_FILTERS_TYPES_ENDPOINT());
    return response.data;
  } catch (error) {
    console.error("Error fetching formulation types filters data", error);

    await logError('local_product_formulation_types_fetch', error, {
      endpoint: LOCAL_PRODUCTS_FILTERS_TYPES_ENDPOINT(),
      response_status: error.response?.status,
      response_data: error.response?.data,
    });

    throw error;
  }
};


export const fetchLocalProductDisclaimerService = async () => {
  try {
    const response = await api.get(LOCAL_PRODUCTS_DISCLAIMER_ENDPOINT());
    return response.data;
  } catch (error) {
    console.error("Error fetching local product disclaimer", error);

    await logError('local_product_disclaimer_fetch', error, {
      endpoint: LOCAL_PRODUCTS_DISCLAIMER_ENDPOINT(),
      response_status: error.response?.status,
      response_data: error.response?.data,
    });

    throw error;
  }
};
